import { AppstoreOutlined } from "@ant-design/icons";
import { Permission, Resource } from "components/CurrentUser/constants";
import BlankLayout from "layouts/BlankLayout";
import { IRouteConfig } from "services/typings";
import { lazy } from "utils/route";

const routes: IRouteConfig[] = [
  {
    path: "/dashboard",
    name: "dashboard.title",
    icon: AppstoreOutlined,
    component: lazy(() => import("pages/DashBoard")),
    permissions: [
      [Resource.DASHBOARD, Permission.FULL_VIEW],
      [Resource.DASHBOARD, Permission.VIEW],
    ],
    placeholderConfig: {
      filter: true,
    },
  },
];

export default routes;
